import React, { useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
  Stack,
  CircularProgress,
} from "@mui/material";
import { toastMessage } from "utils/toastMessage";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
import { makeDealerOnboardStorageKey, clearPersistedDealerOnboard } from "utils/persistForm";

const isHttpUrl = (value) => {
  if (!value || typeof value !== "string") return false;
  return /^https?:\/\//i.test(value);
};

const Section = ({ title, children }) => (
  <Box sx={{ mt: 3 }}>
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 2,
        py: 0.75,
        borderRadius: 999,
        backgroundColor: "rgb(253, 188, 0)",
        boxShadow: 1,
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: 14, lineHeight: 1 }}>
        {title}
      </Typography>
    </Box>
    <Divider sx={{ mt: 1, mb: 2 }} />
    {children}
  </Box>
);

const FieldRow = ({ label, value }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      py: 1,
      px: 1.5,
      borderRadius: 1,
      bgcolor: "grey.50",
      border: "1px solid",
      borderColor: "grey.200",
    }}
  >
    <Typography sx={{ fontWeight: 600, color: "text.secondary" }}>
      {label}
    </Typography>
    <Typography sx={{ color: "text.primary", ml: 2, textAlign: "right" }}>
      {value || "—"}
    </Typography>
  </Box>
);

const toDisplay = (field) => {
  if (!field) return "";
  const code = field?.code;
  const label = field?.label;
  if (label && code) return `${label} (${code})`;
  if (label) return label;
  if (code) return code;
  if (typeof field === "string") return field;
  return "";
};

const Preview = () => {
  const history = useHistory();
  const location = useLocation();
  const { formData = {}, prospectData, dealerId, prospectId, docPreviews = {} } = location.state || {};
  const [submitting, setSubmitting] = useState(false);
  const storageKey = useMemo(
    () => makeDealerOnboardStorageKey(dealerId, prospectId),
    [dealerId, prospectId]
  );
  console.log(formData,"asdfasdfa")
  const sections = useMemo(
    () => [
      {
        title: "SAP & Pricing",
        fields: [
          ["Customer Group", "customer_group"],
          ["Customer Pricing Procedure", "customer_pricing_procedure"],
          ["Terms of Payment", "terms_of_payment"],
          ["Account Assignment Group", "account_assignment_group"],
          // ["Reconciliation Account", "reconciliation_account"],
        ],
      },
      {
        title: "Org Structure",
        fields: [
          ["Account Group", "account_group"],
          // ["Company Code", "company_code"],
          ["Sales Office", "sales_office"],
          ["Distribution Channel", "distribution_channel"],
          ["With SAS", "with_sas"],
        ],
      },
      {
        title: "Customer Classification",
        fields: [
          ["State", "state"],
          ["Customer Class", "customer_class"],
          ["Entity", "status"],
          ["Price Group", "price_group"],
          ["Price List", "price_list"],
        ],
      },
      {
        title: "Address",
        fields: [
          ["Dealership Name", "dealership_name"],
          ["Dealership Address", "dealership_add"],
          ["C/O", "care_of"],
          ["Region", "region"],
          ["District", "district"],
          ["City", "city"],
          ["Postal Code", "postal_code"],
        ],
      },
      {
        title: "Contact",
        fields: [
          ["Name", "contact_person"],
          ["Landline Number", "phone_number"],
          ["Email", "email"],
          ["Mobile Phone", "mobile_phone"],
        ],
      },
      {
        title: "Tax & Compliance",
        fields: [
          ["GST Number", "gst_number"],
          ["PAN", "pan"],
        ],
      },
      {
        title: "Commercial Settings",
        fields: [
          ["Customer Statistic Group", "customer_statistic_group"],
          ["Delivering Plant", "delivering_plant"],
          ["Rebate", "rebate"],
        ],
      },
      {
        title: "Geo & Limits",
        fields: [
          ["Latitude", "latitude"],
          ["Longitude", "longitude"],
        ],
      },
      {
        title: "Extras",
        fields: [
          ["Population of the city", "populationOfCity"],
          ["Regional Office", "regionalOffice"],
          ["No. of Years in Business (Tyre only)", "noOfYearsBusiness"],
          ["Shop Status", "shopStatus"],
          ["Nearest JK Dealer (KM)", "nearestJKDealer"],
          ["Nearest Steel Wheel (KM)", "nearestSteelWheel"],
          ["Competition Brand Shop (KM)", "competitionBrandShop"],
        ],
      },
    ],
    []
  );

  const handleConfirm = async () => {
    try {
      setSubmitting(true);
      const token = localStorage.getItem("token");
      if (!prospectId) {
        toastMessage("Missing prospectId. Please reopen from the list.", "error");
        return;
      }
      if (!token) {
        toastMessage("Auth token missing. Please login again.", "error");
        return;
      }
      const endpoint = `${process.env.REACT_APP_REQUEST_ENDPOINT}/api/v1/actyv/onboarding/user`;
      console.log("endpointasdfasdfsa", formData);
       
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          prospectId,
          form: formData,
        }),
      });
      let json = {};
      try {
        json = await res.json();
      } catch (_) {
        json = {};
      }
      const statusString = String(json?.status || "").toLowerCase();
      const appError =
        json?.success === false ||
        statusString === "error" ||
        statusString === "failed" ||
        statusString === "fail";
      if (!res.ok || appError) {
        const firstError =
          (Array.isArray(json?.errors) && json.errors[0]) ||
          (json?.data && json.data.error) ||
          json?.error;
        const msg = json?.message || firstError || `Failed (HTTP ${res.status})`;
        toastMessage(msg, "error");
        return;
      }
      toastMessage(json.message, "success");
      clearPersistedDealerOnboard(storageKey);
     history.push("/actyv-ai");
    } catch (err) {
      console.error("Preview submit error:", err);
      const msg = err?.message || "Submission failed. Please try again.";
      toastMessage(msg, "error");
    } finally {
      setSubmitting(false);
    }
  };

  const renderSection = (section) => (
    <Section key={section.title} title={section.title}>
      <Grid container spacing={2}>
        {section.fields.map(([label, key]) => {
          const value = toDisplay(formData?.[key]);
          if (!value) return null;
          return (
            <Grid key={key} item xs={12} md={6}>
              <FieldRow label={label} value={value} />
            </Grid>
          );
        })}
      </Grid>
    </Section>
  );

  const documents = [
    ["GST Certificate", "gstCertificate"],
    ["PAN Card", "panCardPhoto"],
    ["CIBIL Score Card", "cibilScoreCard"],
    ["Aadhaar Card Front", "adhaarcardFront"],
    ["Aadhaar Card Back", "adhaarcardBack"],
    ["Cheque Scan", "chequeScan"],
  ].filter(([_, key]) => formData?.[key]?.code);

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
          backgroundColor: "#fff",
        }}
      >
        <Box
          sx={{
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: 0.2 }}>
              Preview Dealer Onboarding
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Review the details below. Click Confirm to submit or Back to edit.
            </Typography>
          </Box>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
            <Button variant="outlined" onClick={() => history.goBack()} disabled={submitting}>
              Back to Edit
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: "rgb(253, 188, 0)", color: "black", fontWeight: 700 }}
              onClick={handleConfirm}
              disabled={submitting}
            >
              {submitting ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <CircularProgress size={18} />
                  <Typography variant="button" sx={{ fontWeight: 700 }}>Submitting...</Typography>
                </Stack>
              ) : (
                "Confirm & Submit"
              )}
            </Button>
          </Stack>
        </Box>

        {sections.map(renderSection)}

        {documents.length > 0 && (
          <Section title="Documents">
            <Grid container spacing={2}>
              {documents.map(([label, key]) => (
                <Grid item xs={12} md={6} key={key}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    {label}
                  </Typography>
            {docPreviews?.[key] ? (
              <Box
                component="img"
                src={docPreviews[key]}
                alt={label}
                sx={{
                  width: "100%",
                  maxHeight: 260,
                  borderRadius: 2,
                  objectFit: "contain",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fafafa",
                }}
              />
            ) : formData?.[key]?.imageUrl ? (
              <Box
                component="img"
                src={formData?.[key]?.imageUrl}
                alt={label}
                sx={{
                  width: "100%",
                  maxHeight: 260,
                  borderRadius: 2,
                  objectFit: "contain",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fafafa",
                }}
              />
            ) : isHttpUrl(formData?.[key]?.code) ? (
              <Box
                component="img"
                src={formData?.[key]?.code}
                alt={label}
                sx={{
                  width: "100%",
                  maxHeight: 260,
                  borderRadius: 2,
                  objectFit: "contain",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fafafa",
                }}
              />
            ) : (
              <Box
                sx={{
                  width: "100%",
                  p: 2,
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fafafa",
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                  Document Number
                </Typography>
                <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                  {formData?.[key]?.code}
                </Typography>
              </Box>
            )}
                </Grid>
              ))}
            </Grid>
          </Section>
        )}
      </Paper>
      <Toaster />
    </Container>
  );
};

export default Preview;


